/**
 * Numerisches deutsches Datumsformat ohne Bestandsvorbild - NEUENTWICKLUNG vom 25.08.2026
 * (`fix/eta-datumsformat-de`), KEIN Portierungsmodul (anders als `lib/format.ts`, dessen
 * Herkunftsmarken `scripts/gen-herkunft.ts` gegen `index.html` gegenprueft, siehe dessen
 * Kopfkommentar). Praezedenzfall im Projekt (`lib/lager.ts`, `lib/orderListEditor.ts`,
 * `lib/zeitstrahlStufen.ts`): ein neues Symbol ohne `index.html`-Entsprechung bekommt ein eigenes,
 * NICHT in `scripts/gen-herkunft.ts#MODULE` gefuehrtes Modul, statt in ein getracktes Modul wie
 * `lib/format.ts` eingeschmuggelt zu werden - sonst wirft `test/reference/herkunft.test.ts` ("keine
 * Herkunftsmarke gefunden"), weil `index.html` diese Funktion nie kannte (gegengeprueft: kein
 * `toLocaleDateString`-Aufruf dort mit numerischem Tag/Monat/Jahr ohne Uhrzeit).
 *
 * WARUM: Reiter „Spedition", Abschnitt „DSV-Sendung" (`Drawer/ShipTab/DsvSendung.tsx`) und
 * `Shipments/DsvWerte.tsx` zeigten die Felder ETA/ETD bisher als rohen ISO-String ("2026-06-08")
 * statt im deutschen Format. `lib/format.ts#fmtDate` (Monatsname, "08. Juni 2026") passt fuer diese
 * reinen Anzeigefelder nicht - gebraucht wird ein rein numerisches Datum ohne Uhrzeit.
 *
 * ================= REIN TEXTLICH statt `new Date(...)` (Nachbesserung, Pruefung 3110ee9) =========
 *
 * Die erste Fassung nutzte `new Date(d).toLocaleDateString(...)`, wie `fmtDate`/`fmtDT` in
 * `lib/format.ts` es tun. Fuer die Zeitangaben hier (ETA/ETD, reine Kalenderdaten "YYYY-MM-DD" ohne
 * Uhrzeit) ist das falsch: `new Date("2026-06-08")` ist UTC-Mitternacht - in Zeitzonen WESTLICH von
 * UTC (z. B. `America/New_York`) rutscht `toLocaleDateString` auf den VORTAG ("07.06.2026" statt
 * "08.06.2026"), weil die Umwandlung in die lokale Zeitzone vor der Formatierung passiert. `fmtDT`
 * betrifft das nicht - der dort formatierte `lastSyncedAt` traegt eine ECHTE Uhrzeit (ISO mit
 * Zeitanteil), ein Kalenderdatum ohne Uhrzeit dagegen hat gar keine "Ortszeit", die verschieben
 * koennte.
 *
 * Das Projekt kennt diese Falle bereits zweimal, beide Male ueber Textzerlegung geloest, OHNE
 * `Date`-Umweg:
 * - `backend/src/zeit/berlin.ts#deutschesDatum` ("Rein textlich, damit keine Zeitzone hineinspielt").
 * - `components/Shipments/SendungsSuche.tsx#datumDe` (bis zu dieser Nachbesserung eine EIGENE, zweite
 *   Fassung derselben Textzerlegung, direkt in dieser Komponente - siehe deren Aufrufer `zeitangabe()`
 *   unten importiert statt dupliziert).
 *
 * `fmtDateNum` uebernimmt denselben Weg als die eine kanonische Fassung fuer beide Aufrufer.
 */

/**
 * "YYYY-MM-DD" -> "TT.MM.JJJJ", rein textlich (kein `Date`-Umweg, siehe Kopfkommentar). Trifft das
 * Muster nicht (leer, `null`/`undefined`, oder ein anderes Format), kommt der Rohwert unveraendert
 * zurueck statt eines kaputten "Invalid Date" - ausser bei `null`/`undefined`/leer, dort "".
 */
export const fmtDateNum = (d: string | null | undefined): string => {
  if (!d) return "";
  const treffer = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
  return treffer ? `${treffer[3]}.${treffer[2]}.${treffer[1]}` : d;
};
